import { getShopperId } from '../util/auth';
import { getOrderDataFromLocalStorage } from '../util/localStorage';
import { trackVatIdSaveToAccountError } from './newRelicTrackingApi';
import { dispatchPutRequest } from '../util/apiUtils.ts';

const SHOPPER_VAT_SERVICE_URL_ENV = process.env.SHOPPER_VAT_SERVICE_BASE_URL;
const validTaxIdEndpoints = ['vatIds', 'inGstins'];

export const saveVatIdToShopperAccount = async (orderId, siteName) => {
  const shopperId = getShopperId();
  const orderDetails = getOrderDataFromLocalStorage(orderId) || {};
  const { vatId, taxIdType } = orderDetails;

  if (vatId) {
    // taxIdType could be one of 'vatIds' or 'inGstins'. If not specified fallback to saving in 'vatIds'
    const endpointTaxIdType =
      taxIdType && validTaxIdEndpoints.includes(taxIdType)
        ? taxIdType
        : 'vatIds';
    const url = `${SHOPPER_VAT_SERVICE_URL_ENV}/shopper/${shopperId}/${endpointTaxIdType}/${vatId}`;

    try {
      await dispatchPutRequest({ url, timeout: 10000 });
    } catch (err) {
      // TODO: Track with new newrelic tracker.
      trackVatIdSaveToAccountError(err, shopperId, vatId, siteName);
    }
  }
};
